export default Object.freeze({
  hetzner: "hetzner-full",
  scaleway: "scaleway-full",
  outscale: "outscale-full",
});
